













    import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
    import DateTime from '@/types/DateTime';
    import $ from 'jquery';
    import '@fortawesome/fontawesome-free/css/all.css';
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import moment from 'moment';
    import 'moment/locale/hr';

    @Component({
        inheritAttrs: false,
        components: {
            'b-date-picker': datePicker
        }
    })
    export default class DateTimePicker extends Vue {
        @Prop() id!: string;
        @Prop() value!: moment.Moment | undefined
        @Prop() locale!: string;
        @Prop({ default: null }) placeholder!: string | null;
        @Prop({ default: null }) state!: boolean | null;
        @Prop({ default: false }) required!: boolean;
        @Prop({ default: false }) readonly!: boolean;
        @Prop({ default: false }) onlyDate!: boolean;
        @Prop({ default: false }) onlyTime!: boolean;
        @Prop({ default: false }) wrap!: boolean;
        @Prop({ default: false }) disabled!: boolean;

        localValue: moment.Moment | undefined = this.value;
        hover = false;
        dateTimeFormat: string = DateTime.formats.dateTime;
        options: DatePickerOptions = {
            date: null,
            format: '',
            locale: '',
            useCurrent: false,
            showTodayButton: true,
            showClear: true,
            showClose: true,
            allowInputToggle: true,
            icons: {},
            tooltips: {}
        };

        @Watch('value')
        refreshData(newVal: string) {
            if (newVal) {
                Vue.nextTick(() => {
                    this.localValue = DateTime.toUtc(newVal, this.dateTimeFormat);
                });
            }
        }

        @Watch('locale')
        refreshLocale(newVal: string) {
            if (newVal) {
                const val = this.value;
                this.init();
                //this.options.locale = newVal;
                DateTime.setLocale(newVal);
                Vue.nextTick(() => {
                    this.localValue = val;
                });
            }
        }

        @Watch('state')
        updateState(newVal: boolean) {
            if (newVal == false) {
                this.$el.classList.add('is-invalid');
            }
            else {
                this.$el.classList.remove('is-invalid');
            }
        }

        @Watch('disabled')
        updateDisabled(newVal: boolean) {
            $(this.$el).prop('disabled', newVal);
        }

        mounted() {
            this.init();
        }

        init() {
            if (this.readonly === true) {
                return;
            }

            this.dateTimeFormat = this.onlyDate === true
                ? DateTime.formats.date
                : this.onlyTime === true
                    ? DateTime.formats.time
                    : DateTime.formats.dateTime;

            this.options = {
                date: null,
                format: this.dateTimeFormat,
                locale: this.locale,
                useCurrent: false,
                showTodayButton: true,
                showClear: true,
                showClose: true,
                allowInputToggle: true,
                icons: {
                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle'
                },
                tooltips: {
                    today: this.$t('tooltips.today').toString(),
                    clear: this.$t('tooltips.clear').toString(),
                    close: this.$t('tooltips.close').toString(),
                    selectMonth: this.$t('tooltips.selectMonth').toString(),
                    prevMonth: this.$t('tooltips.prevMonth').toString(),
                    nextMonth: this.$t('tooltips.nextMonth').toString(),
                    selectYear: this.$t('tooltips.selectYear').toString(),
                    prevYear: this.$t('tooltips.prevYear').toString(),
                    nextYear: this.$t('tooltips.nextYear').toString(),
                    selectDecade: this.$t('tooltips.selectDecade').toString(),
                    prevDecade: this.$t('tooltips.prevDecade').toString(),
                    nextDecade: this.$t('tooltips.nextDecade').toString(),
                    prevCentury: this.$t('tooltips.prevCentury').toString(),
                    nextCentury: this.$t('tooltips.nextCentury').toString()
                }
            };
        }

        // eslint-disable-next-line
        onChange(e: ChangeEventArgs) {
            if (!e.date) {
                this.$emit('change', null);
            }
            else {
				this.localValue = (e.date as moment.Moment).utcOffset(0, true);
                const localOldVal = e.oldDate as moment.Moment;
				if (this.localValue && (!localOldVal || localOldVal != this.localValue)) {
					this.$emit('change', this.localValue);
                }
            }
        }

        destroy() {
            this.performAction('destroy');
        }

        performAction(action: string) {
            return $(this.id).datetimepicker(action);
        }

        destroyed() {
            this.destroy();
        }
    }

    interface ChangeEventArgs {
        date: number | string | Date | moment.Moment | moment.MomentInputObject | undefined;
        oldDate: number | string | Date | moment.Moment | moment.MomentInputObject | undefined;
    }

    interface DatePickerOptions {
        date: moment.Moment | null;
        format: string;
        locale: string;
        useCurrent: boolean | string;
        showTodayButton: boolean;
        showClear: boolean;
        showClose: boolean;
        allowInputToggle: boolean;
        icons?: DatePickerOptionsIcons;
        tooltips?: DatePickerOptionsTooltips;
    }

    interface DatePickerOptionsIcons {
        time?: string;
        date?: string;
        up?: string;
        down?: string;
        previous?: string;
        next?: string;
        today?: string;
        clear?: string;
        close?: string;
    }

    interface DatePickerOptionsTooltips {
        today?: string;
        clear?: string;
        close?: string;
        selectMonth?: string;
        prevMonth?: string;
        nextMonth?: string;
        selectYear?: string;
        prevYear?: string;
        nextYear?: string;
        selectDecade?: string;
        prevDecade?: string;
        nextDecade?: string;
        prevCentury?: string;
        nextCentury?: string;
    }
